
export interface MenuButtonData {
        display: string,
        path: string
        level?: number,
        type?: MenuButtonLinkType
}

export enum MenuButtonLinkType {
        SubMenu = "subMenu",
        ReportMenu = "reportMenu",
        Navigate = "Navigate",
        WindowOpen = "WindowOpen"
}